import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    textAlign: 'center',

    '& img': {
      filter: `drop-shadow(${theme.spacing(0.5)} 0 ${theme.spacing(0.5)} black)`,
    },
  },
}));
